<template>
  <div class="page-seckill"
       :class="[
         { 'is-empty': showEmpty }
       ]"
  >
    <ym-img v-if="banner !== ''"
            class="page-seckill-banner"
            :src="banner"
    />
    <seckill-progress v-if="progress && progress.days.length > 0"
                      class="page-seckill-progress"
                      :title="progress.title"
                      :days="progress.days"
                      :current-time="progress.currentTime"
    />
    <div class="page-seckill-content">
      <div v-for="(block, index) in blocks"
           :key="index"
           class="page-seckill-block"
      >
        <grid-block v-if="showGrid(block.viewMode)"
                    :block="block"
                    :current-time="render.currentTime"
                    @show-guide-mask="handleGuideMask"
                    @show-book-mobile="handleShowBookPopup"
                    @show-next-seckill="handleShowNextSeckill"
        />
        <list-block v-else
                    :block="block"
                    @show-book-mobile="handleShowBookPopup"
                    @show-next-seckill="handleShowNextSeckill"
        />
      </div>
      <seckill-btn v-if="render.button && render.button.show"
                   class="page-seckill-share-btn"
                   v-ym-report:SECKILL_HOME_BOTTOM_BTN_CLICK="render.button"
                   @click="handleClickBottomBtn"
      >
        {{ render.button.hint }}
      </seckill-btn>
    </div>

    <empty-page v-if="showEmpty"
                class="page-seckill-empty"
                model="content"
                hint="暂无秒杀活动"
    />

    <seckill-state-popup :show.sync="statePopup.show"
                         :icon="statePopup.icon"
                         :title="statePopup.title"
                         :message="statePopup.message"
                         :button="statePopup.button"
    />
    <seckill-book-popup :show.sync="bookPopup.show"
                        :target="bookPopup.target"
    />
    <seckill-guide-mask :show.sync="showGuideMask" />
  </div>
</template>

<script>
  import { getSeckillIndex } from '@/services/seckill';
  import SeckillProgress from '@/pages/Seckill/components/SeckillProgress';
  import GridBlock from '@/pages/Seckill/components/SeckillGridBlock';
  import ListBlock from '@/pages/Seckill/components/SeckillListBlock';
  import SeckillBtn from '@/pages/Seckill/components/SeckillBtn';
  import SeckillStatePopup from '@/pages/Seckill/components/SeckillStatePopup';
  import SeckillBookPopup from '@/pages/Seckill/components/SeckillBookPopup';
  import SeckillGuideMask from '@/pages/Seckill/components/SeckillGuideMask';
  import EmptyPage from '@/components/EmptyPage';
  import { locationHref, getSeckillGuideMaskStorage } from '@/utils';

  export default {
    name: 'PageSeckill',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      SeckillProgress,
      GridBlock,
      ListBlock,
      SeckillBtn,
      SeckillStatePopup,
      SeckillBookPopup,
      SeckillGuideMask,
      EmptyPage,
    },
    data() {
      return {
        banner: '',
        progress: {
          title: '',
          days: [],
          currentTime: 0,
        },
        blocks: [],
        render: {
          pageTitle: '',
          subscribeMessageNotify: {
            show: false,
            title: '',
            message: '',
            button: null,
          },
          button: {
            show: false,
            hint: '',
            url: '',
          },
          currentTime: 0,
        },

        statePopup: {
          show: false,
          icon: '',
          title: '',
          message: '',
        },

        showShareMask: false,

        bookPopup: {
          show: false,
          target: {
            id: 0,
            type: 'seckill',
          },
        },

        showGuideMask: false,

        loaded: false,
      };
    },
    computed: {
      sharePath() {
        return window.location.href;
      },
      subscribeMessageNotify() {
        return this.render.subscribeMessageNotify;
      },
      showEmpty() {
        return this.loaded && this.blocks.length === 0;
      },
    },
    methods: {
      showGrid(mode) {
        return [
          'largeGrid',
        ].includes(mode);
      },
      handleShowStatePopup(data) {
        // 处理数据
        const {
          icon, title, message, button,
        } = data;
        this.statePopup.icon = icon;
        this.statePopup.title = title;
        this.statePopup.message = message;
        this.statePopup.button = button;
        // 展示popup
        this.statePopup.show = true;
      },
      async fetchData(params) {
        this.loaded = false;

        const data = await getSeckillIndex(params);

        this.banner = data.banner;
        this.progress = data.progress;
        this.blocks = data.blocks;
        this.render = data.render;

        // 处理订阅消息弹窗
        let { subscribeMessageNotify } = data.render;
        if (subscribeMessageNotify == null) {
          subscribeMessageNotify = {
            show: false,
            icon: '',
            title: '',
            message: '',
            button: null,
          };
        }
        if (subscribeMessageNotify.show) {
          this.handleShowStatePopup(subscribeMessageNotify);
        }

        this.loaded = true;
      },
      handleGuideMask() {
        const storage = getSeckillGuideMaskStorage();
        if (storage === '1') return;
        this.showGuideMask = true;
      },
      handleShowNextSeckill(next) {
        this.handleShowStatePopup(next);
      },
      handleClickBottomBtn() {
        const { button } = this.render;
        const { url } = button;
        locationHref(url);
      },
      handleShowBookPopup(target) {
        this.bookPopup.target = target;
        this.bookPopup.show = true;
      },
    },
    created() {
      const { query } = this.$route;
      this.fetchData(query);
    },
    beforeRouteUpdate(to, from, next) {
      const { query } = to;
      this.fetchData(query);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-seckill {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: @size-large;
    background: @seckill-background;

    &.is-empty {
      background: @color-white;
    }

    &-banner {
      display: block;
      width: 100%;
    }

    &-content {
      padding: 0 @size-small;
    }

    &-block {
      margin-top: @size-extra-large;
    }

    &-share {
      &-btn {
        margin: @size-large auto 0;
      }

      &-icon {
        font-size: 40px;
      }
    }

    &-empty {
      margin-top: @size-medium * 2;
    }
  }
</style>
